// extracted by mini-css-extract-plugin
module.exports = {"blueColor":"#3b84e6"};